module.exports = __webpack_public_path__ + "img/header-weddingRingstrisets.1e56704.jpg";